import { BackgroundCheckStatus, BackgroundCheckType } from '../types';
import {
    autoBackgroundCheckConfigStatuses,
    defaultBackgroundCheckConfigFilters,
    manualBackgroundCheckConfigStatuses,
} from './defaultBackgroundCheckStatuses';

export interface BackgroundCheckConfig {
    client: string;
    type: { [key in BackgroundCheckType]: BackgroundCheckConfigByType };
}

export interface BackgroundCheckConfigByType {
    enabled: boolean;
    default: boolean;
    label: string;
    statuses: {
        status: BackgroundCheckStatus;
        label: string;
        enabled: boolean;
    }[];
    filter: {
        clear: BackgroundCheckStatus[];
        ready: BackgroundCheckStatus[];
        failed: BackgroundCheckStatus[];
        processing: BackgroundCheckStatus[];
    };
}

export const defaultBackgroundCheckConfig: BackgroundCheckConfig = {
    client: 'Juvare',
    type: {
        manual: {
            enabled: true,
            default: true,
            label: 'Manual Background Check',
            statuses: [...manualBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
        },
        criminalSuper: {
            enabled: false,
            default: false,
            label: 'Super Search Background Check',
            statuses: [...autoBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
        },
        legacySexOffender: {
            enabled: false,
            default: false,
            label: 'Legacy Sex Offender',
            statuses: [...autoBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
        },
        standard: {
            enabled: false,
            default: false,
            label: 'Standard',
            statuses: [...autoBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
        },
    },
};
